import { jsx as _jsx } from "react/jsx-runtime";
import { Grid } from '@mui/material';
import { StripedDataGrid } from '../../factories/DataGrid/styles/striped';
import { fontSize } from '../cellFormatters/fontSize';
import { gatewayColumnMap } from './config/columnMap';
export const LSCGatewayMessageTable = ({ selectedGateway, deviceMessages, loading, columnVisibilityModel, onColumnVisibilityModelChange, everyNth, }) => {
    const dataGridProps = {
        density: 'compact',
        columns: Object.entries(gatewayColumnMap).map(([k, v]) => ({ field: k, ...v })),
        rows: deviceMessages.map((val, i) => ({ ...val, id: i })),
        getRowClassName: (params) => (params.indexRelativeToCurrentPage % 2 === 0 ? 'even' : 'odd'),
        loading,
        columnVisibilityModel,
        onColumnVisibilityModelChange,
        rowHeight: 32,
        columnHeaderHeight: 32,
        hideFooter: deviceMessages.length <= 100,
        hideFooterPagination: deviceMessages.length <= 100,
        disableColumnMenu: false,
        disableColumnSorting: true,
        disableColumnSelector: true,
        disableColumnResize: true,
        disableVirtualization: true,
        sx: {
            [`& .MuiDataGrid-cell`]: {
                ['&[data-field="consumedAirtimeSecs"], &[data-field="esp"], &[data-field="rssi"], &[data-field="snr"], &[data-field="sf"], &[data-field="dr"], &[data-field="power"]']: {
                    padding: 0,
                },
            },
        },
    };
    return (_jsx(Grid, { container: true, style: { fontSize, width: '100%' }, children: _jsx(Grid, { size: { xs: 12 }, sx: { minHeight: '20vh', maxHeight: '70vh', overflowY: 'auto' }, children: _jsx(StripedDataGrid, { style: { fontSize: 'inherit' }, ...dataGridProps }) }) }));
};
